/* Mon Petit Herbier — fiche produit : menu d'ancres + accordéons mobiles */
(function () {
  var root = document.querySelector('.mph-pc');
  if (!root) return;
  // Hauteur réelle de la barre d'achat fixe (elle dépend de la longueur du titre) : le bouton de fidélité se place
  // juste au-dessus grâce à la variable --mph-barre-achat, lue par mph-product.css.
  var barreAchat = document.getElementById('yvProductStickyBar');
  if (barreAchat && 'ResizeObserver' in window) {
    var poserBarre = function () { document.body.style.setProperty('--mph-barre-achat', barreAchat.offsetHeight + 'px'); };
    new ResizeObserver(poserBarre).observe(barreAchat);
    poserBarre();
  }
  var list = root.querySelector('[data-mph-nav]');
  // toutes les sections MPH de la page, y compris la FAQ qui vit dans sa propre section après les avis
  var secs = [].slice.call(document.querySelectorAll('.mph-pc__sec'));
  var targets = [];
  // Sections du thème (avis Judge.me, produits recommandés) : même mise en page que les sections MPH
  function wrapSection(sectionEl, label, id, tint, full) {
    if (!sectionEl || sectionEl.querySelector('.mph-wrap')) return null;
    var wrap = document.createElement('div');
    wrap.className = 'mph-wrap' + (tint ? ' mph-wrap--tint' : '');
    wrap.id = id;
    var container = document.createElement('div');
    container.className = 'container mph-pc__grid';
    var h = document.createElement('h2');
    h.className = 'mph-pc__label';
    h.textContent = label;
    var body = document.createElement('div');
    body.className = full ? 'mph-reco' : 'mph-pc__body';
    while (sectionEl.firstChild) body.appendChild(sectionEl.firstChild);
    container.appendChild(h); container.appendChild(body); wrap.appendChild(container); sectionEl.appendChild(wrap);
    return wrap;
  }
  var reviewsWidget = document.getElementById('judgeme_product_reviews');
  var reviewsSection = reviewsWidget && reviewsWidget.closest('.shopify-section');
  // Les fonds sont fixes par type de section (plus d'alternance) : rien ne change de couleur quand une section manque.
  var reviewsLabel = root.getAttribute('data-reviews-label') || 'Avis clients';
  var sansAvis = root.getAttribute('data-nb-avis') === '0';
  var reviewsWrap = null;
  if (sansAvis) {
    if (reviewsSection) reviewsSection.style.display = 'none'; // pas de section vide : la ligne sous le titre explique comment noter
  } else {
    reviewsWrap = wrapSection(reviewsSection, reviewsLabel, 'mph-avis', false, false);
  }
  var famille = root.getAttribute('data-famille') || '';
  // Les produits proposés en bas de fiche sont des produits proches (recommandations de Shopify), pas des compléments :
  // le titre le dit, sans promettre une « routine » ou des produits « pour aller avec ».
  var recoByFamille = { huiles: 'Vous aimerez aussi', animaux: 'À découvrir pour votre animal', fleurs: 'Vous aimerez aussi', resines: 'Vous aimerez aussi', cosmetiques: 'Vous aimerez aussi', alimentaire: 'Vous aimerez aussi', vape: 'Vous aimerez aussi', accessoires: 'Vous aimerez aussi' };
  var recoSection = document.querySelector('.shopify-section.product-page-recommendations');
  var recoLabel = recoByFamille[famille] || (recoSection && recoSection.querySelector('h2') ? recoSection.querySelector('h2').textContent.trim() : 'Produits recommandés');
  if (reviewsWrap && root.getAttribute('data-note-avis')) {
    // qui peut laisser un avis, et comment : la question revient souvent
    var noteAvis = document.createElement('p'); noteAvis.className = 'mph-avis-note';
    noteAvis.textContent = root.getAttribute('data-note-avis');
    var corpsAvis = reviewsWrap.querySelector('.mph-pc__body');
    if (corpsAvis) corpsAvis.insertBefore(noteAvis, corpsAvis.firstChild);
  }
  var recoWrap = wrapSection(recoSection, recoLabel, 'mph-recommandes', false, true);
  // raccourcis dans l'ordre de la page : sections MPH, avis, FAQ, produits recommandés
  [].slice.call(document.querySelectorAll('.mph-pc__sec, #mph-avis, #mph-recommandes')).forEach(function (el) {
    var label = el === reviewsWrap ? reviewsLabel : (el === recoWrap ? recoLabel : el.querySelector('.mph-pc__label').textContent.trim());
    targets.push({ el: el, label: label });
  });

  // Accordéons (mobile uniquement, via CSS) : la première section reste ouverte
  secs.forEach(function (s, i) {
    var h = s.querySelector('.mph-pc__label');
    if (i === 0) s.classList.add('is-open');
    h.setAttribute('tabindex', '0');
    h.setAttribute('role', 'button');
    h.setAttribute('aria-expanded', i === 0 ? 'true' : 'false');
    function toggle() {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var open = s.classList.toggle('is-open');
      h.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    h.addEventListener('click', toggle);
    h.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
    });
  });

  // Avis clients : même accordéon que les autres sections sur mobile (replié au départ ; les avis restent dans la page)
  function ouvrirAvis() {
    if (!reviewsWrap) return;
    reviewsWrap.classList.add('is-open');
    reviewsWrap.querySelector('.mph-pc__label').setAttribute('aria-expanded', 'true');
  }
  if (reviewsWrap) {
    reviewsWrap.classList.add('mph-wrap--acc');
    var hAvis = reviewsWrap.querySelector('.mph-pc__label');
    hAvis.setAttribute('tabindex', '0');
    hAvis.setAttribute('role', 'button');
    hAvis.setAttribute('aria-expanded', 'false');
    var basculerAvis = function () {
      if (!window.matchMedia('(max-width: 749px)').matches) return;
      var ouvert = reviewsWrap.classList.toggle('is-open');
      hAvis.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    };
    hAvis.addEventListener('click', basculerAvis);
    hAvis.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); basculerAvis(); }
    });
    // le nombre d'avis s'affiche dans le titre dès que Judge.me l'a chargé
    var compter = function () {
      var w = reviewsWrap.querySelector('.jdgm-rev-widg'), n = w && parseInt(w.getAttribute('data-number-of-reviews'), 10);
      if (!n || hAvis.querySelector('.mph-pc__nb')) return;
      var nb = document.createElement('span'); nb.className = 'mph-pc__nb'; nb.textContent = ' (' + n + ')';
      hAvis.appendChild(nb);
    };
    compter(); setTimeout(compter, 1500); setTimeout(compter, 4000);
    // les étoiles sous le titre du produit, ou un lien direct vers les avis, ouvrent l'accordéon
    document.addEventListener('click', function (e) {
      var c = e.target.closest ? e.target.closest('.jdgm-prev-badge, a[href$="#mph-avis"], a[href$="#judgeme_product_reviews"]') : null;
      if (c) ouvrirAvis();
    });
    if (location.hash === '#mph-avis' || location.hash === '#judgeme_product_reviews') ouvrirAvis();
    // la note sous le titre du produit mène aux avis (et les déplie sur mobile)
    var note = document.querySelector('.yv-main-product-detail .ratingbox');
    if (note) {
      note.classList.add('mph-note-lien'); note.setAttribute('role', 'link'); note.setAttribute('tabindex', '0');
      var allerAuxAvis = function () { ouvrirAvis(); reviewsWrap.scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      note.addEventListener('click', allerAuxAvis);
      note.addEventListener('keydown', function (e) { if (e.key === 'Enter') allerAuxAvis(); });
    }
  }

  // Description longue : repli avec bouton « Lire la suite » (le texte reste dans la page pour les moteurs)
  (function () {
    var desc = root.querySelector('#mph-description .mph-pc__body');
    if (!desc) return;
    var limit = window.matchMedia('(max-width: 749px)').matches ? 460 : 640;
    if (desc.scrollHeight < limit + 260) return;
    desc.classList.add('mph-clamp');
    desc.id = desc.id || 'mph-description-texte';
    var btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'mph-more'; btn.textContent = 'Lire la suite';
    btn.setAttribute('aria-expanded', 'false'); btn.setAttribute('aria-controls', desc.id);
    desc.parentNode.insertBefore(btn, desc.nextSibling);
    function open() { desc.classList.remove('mph-clamp'); btn.setAttribute('aria-expanded', 'true'); btn.hidden = true; }
    btn.addEventListener('click', open);
    // un lien d'ancre ou une recherche dans la page vers un passage replié l'ouvre
    desc.addEventListener('focusin', open);
    if (location.hash && desc.querySelector(location.hash)) open();
  })();

  // Pastille de remise à côté du prix : le thème réécrit le prix quand le format change, on recalcule alors la remise
  (function () {
    var boite = document.querySelector('.yv-main-product-detail [data-price-main], [data-price-main]');
    if (!boite || !('MutationObserver' in window)) return;
    function nombre(el) { if (!el) return 0; var m = el.textContent.replace(/\s/g, '').match(/(\d+)(?:[.,](\d{1,2}))?/); return m ? parseFloat(m[1] + '.' + (m[2] || '0')) : 0; }
    var unites = {}; try { unites = JSON.parse(boite.getAttribute('data-mph-unites') || '{}'); } catch (e) {}
    function majUnite() {
      // prix à l'unité (« 3,49 € / g ») du format choisi : le thème réaffichait celui du premier format
      var champ = document.querySelector('.main-product-form [name="id"]') || document.querySelector('form[action*="/cart/add"] [name="id"]');
      var id = champ && champ.value, u = boite.querySelector('.yv-product-unit-price');
      if (!id || !Object.keys(unites).length) return;
      if (unites[id]) {
        if (!u) { u = document.createElement('p'); u.className = 'yv-product-unit-price'; boite.appendChild(u); }
        if (u.textContent.trim() !== unites[id]) u.textContent = unites[id];
      } else if (u) { u.remove(); }
    }
    function maj() {
      majUnite();
      var barre = boite.querySelector('.yv-product-compare-price'), prix = boite.querySelector('.yv-product-price');
      var pastille = boite.querySelector('.mph-remise-prix');
      var a = nombre(barre), p = nombre(prix), pct = a > p && p > 0 ? Math.round((a - p) * 100 / a) : 0;
      if (!pct) { if (pastille) pastille.remove(); return; }
      var txt = '\u2212' + pct + '\u00a0%';
      if (pastille) { if (pastille.textContent !== txt) pastille.textContent = txt; return; }
      pastille = document.createElement('span'); pastille.className = 'mph-remise-prix'; pastille.textContent = txt;
      barre.parentNode.insertBefore(pastille, barre.nextSibling);
    }
    new MutationObserver(maj).observe(boite, { childList: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(maj, 120); });
    maj();
  })();

  // Vente croisée sous le bouton : le produit complémentaire défini dans Search & Discovery ; sans lui, la ligne reste masquée
  (function () {
    var bloc = document.querySelector('[data-mph-compl]');
    if (!bloc || !window.fetch) return;
    fetch(bloc.getAttribute('data-url'), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        // jusqu'à trois compléments par ordre de préférence : on montre le premier en stock
        // produits réservés aux clients connectés (étiquette reserve-clients, 16/10/2026) : jamais proposés à un visiteur non connecté
        var connecte = bloc.hasAttribute('data-connecte');
        var pr = d && d.products && d.products.filter(function (x) { return x.available && (connecte || (x.tags || []).indexOf('reserve-clients') < 0); })[0];
        if (!pr) return;
        var a = document.createElement('a'); a.className = 'mph-compl__produit'; a.href = pr.url;
        var img = pr.featured_image ? '<img src="' + String(pr.featured_image).replace(/(\.[a-z]+)(\?|$)/i, '_96x96$1$2') + '" alt="" width="48" height="48" loading="lazy">' : '';
        var prix = (pr.price / 100).toFixed(2).replace('.', ',') + ' €';
        a.innerHTML = img + '<span><small>Compléter avec</small><b></b></span><em></em>';
        // Bouton « + » : ajout direct au panier ; le reste de la ligne mène à la fiche du produit.
        // Quand le complément existe en plusieurs formats ou couleurs, la ligne nomme celui qui sera ajouté
        // (le premier en stock) et affiche son prix : pour en choisir un autre, on passe par la fiche.
        var tous = pr.variants || [];
        var vars = tous.filter(function (v) { return v.available; });
        var nom = pr.title;
        if (tous.length > 1 && vars[0]) {
          nom = pr.title + ' – ' + vars[0].title;
          prix = (vars[0].price / 100).toFixed(2).replace('.', ',') + ' €';
          a.href = pr.url + (pr.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + vars[0].id;
        }
        a.querySelector('b').textContent = nom;
        a.querySelector('em').textContent = prix;
        var ligne = document.createElement('div'); ligne.className = 'mph-compl__ligne'; ligne.appendChild(a);
        if (vars[0]) {
          var racine = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          var btn = document.createElement('button'); btn.type = 'button'; btn.className = 'mph-compl__ajout';
          btn.setAttribute('aria-label', 'Ajouter ' + nom + ' au panier'); btn.title = 'Ajouter au panier';
          btn.innerHTML = '<span aria-hidden="true">+</span>';
          var etat = document.createElement('span'); etat.className = 'yv-visually-hidden'; etat.setAttribute('role', 'status');
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            btn.disabled = true; btn.classList.add('is-attente');
            fetch(racine + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: vars[0].id, quantity: 1 }] }) })
              .then(function (r) { if (!r.ok) throw new Error('ajout'); return r.json(); })
              .then(function () { return fetch(racine + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); })
              .then(function (panier) {
                btn.classList.remove('is-attente'); btn.classList.add('is-fait');
                btn.innerHTML = '<span aria-hidden="true">✓</span>'; btn.setAttribute('aria-label', nom + ' ajouté au panier');
                etat.textContent = nom + ' ajouté au panier';
                // compteur et contenu du panier mis à jour par le thème, sans ouvrir le tiroir : on reste sur la fiche
                try { if (typeof buildCart === 'function') buildCart(panier, false); } catch (e) {}
                setTimeout(function () { btn.disabled = false; btn.classList.remove('is-fait'); btn.innerHTML = '<span aria-hidden="true">+</span>'; btn.setAttribute('aria-label', 'Ajouter ' + nom + ' au panier'); }, 4000);
              })
              .catch(function () { btn.disabled = false; btn.classList.remove('is-attente'); etat.textContent = 'Ajout impossible pour le moment'; });
          });
          ligne.appendChild(btn); ligne.appendChild(etat);
        }
        bloc.innerHTML = ''; bloc.appendChild(ligne); bloc.hidden = false;
      })
      .catch(function () {});
  })();

  if (targets.length < 2) { root.querySelector('.mph-pc__nav').hidden = true; return; }
  var links = targets.map(function (t) {
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + t.el.id;
    var shortLabels = { "Fiche d'identité": 'Identité', "Conseils d'utilisation": 'Utilisation', "Conseils d’utilisation": 'Utilisation', "Conseils d'utilisation et bienfaits": 'Utilisation', "Conseils d’utilisation et bienfaits": 'Utilisation', 'Composition & analyses': 'Composition', 'Actifs & ingrédients': 'Composition', 'Ingrédients & composition': 'Composition', 'Questions fréquentes': 'FAQ', 'Avis clients': 'Avis', 'Origines et traçabilité': 'Origine', 'Produits recommandés': 'Recommandés', 'Complétez votre routine': 'Recommandés', 'À découvrir pour votre animal': 'Recommandés', 'Vous aimerez aussi': 'Recommandés', 'Pour aller avec': 'Recommandés' };
    a.textContent = shortLabels[t.label] || t.label;
    a.addEventListener('click', function () {
      if (t.el.classList.contains('mph-pc__sec')) {
        t.el.classList.add('is-open');
        t.el.querySelector('.mph-pc__label').setAttribute('aria-expanded', 'true');
      }
      if (t.el === reviewsWrap) ouvrirAvis();
    });
    li.appendChild(a);
    list.appendChild(li);
    return a;
  });
  if (!('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      links.forEach(function (l) { l.classList.toggle('is-active', l.getAttribute('href') === '#' + e.target.id); });
    });
  }, { rootMargin: '-35% 0px -55% 0px' });
  targets.forEach(function (t) { io.observe(t.el); });
})();
